/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2019,
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Events',
	'../../widgets/livewidget/nls/StringResources'
], function(Events, stringResources) {
	'use strict';
	var DeleteFilterAction = null;

	//Constants
	var ACTION_ID = 'deleteFilterAction';

	DeleteFilterAction = Events.extend({

		/**
		 * init method for the aggregation type action
		 * @param visModel - internal model (representation) of the current visualization of interest
		 * @param metadataColumn - The metadataColumn this filter to be deleted.
		 * @param filterId (optional) - The uniqueId of the filter to be deleted.
		 */
		init: function(visModel, metadataColumn, filterId) {
			DeleteFilterAction.inherited('init', this, arguments);

			this.visModel = visModel;
			this.widget = visModel.ownerWidget;
			this.transactionApi = this.widget.dashboardApi.getFeature('Transaction');
			this.metadataColumn = metadataColumn;
			this.filterId = filterId;
			const iconsFeature = this.widget.dashboardApi.getFeature('Icons');
			const deleteIcon = iconsFeature.getIcon('trashIcon');

			this.toolbarContribution = [{
				name: 'delete',
				text: stringResources.get('toolbarDeleteFilterActionText'),
				label: stringResources.get('toolbarDeleteFilterActionText'),
				icon: deleteIcon.id,
				type: 'Button',
				removeOnActionApplied: true,
				action: this.deleteLocalFilter.bind(this),
				group: ACTION_ID
			}];
		},

		/**
		 * This method will return the action id for this action (such as aggregationTypeAction, sortAction, etc....)
		 * @returns action id - a string describing this particular action.
		 */
		getActionId: function() {
			return ACTION_ID;
		},

		/**
		 * get the set of availableSort actions setting the selected state to match
		 * the state of the data.
		 * @returns the sort actions and their state.
		 */
		getAvailableActions: function() {
			return this.toolbarContribution;
		},

		/**
		 * Delete the filter defined in the filterId attribute or by metadataColumn.
		 * Delete by filterId allows support for 'AdditionalFilters' (ie: multiple keeps/excludes on the same item).
		 */
		deleteLocalFilter: function() {
			var filterKey = (this.filterId) ? {
				id: this.filterId
			} : this._getFilterKeyFromMetadataColumn();
			if (filterKey) {
				//The new removeFilter API uses 'itemId' as the filter key
				filterKey.itemId = filterKey.itemId || filterKey.id;

				const localFilters = this.widget.getVisualizationApi().getLocalFilters();
				const transactionToken = this.transactionApi.startTransaction();

				localFilters.removeFilter(filterKey, transactionToken);
				this.transactionApi.endTransaction(transactionToken);
			}
		},

		//When using metadataColumn, delete the first filter with this columnId and aggregation type.
		//TODO: Kept for backwards compatibility.  Delete by columnId is likely deprecated.
		_getFilterKeyFromMetadataColumn: function() {
			var filterToDelete = this.metadataColumn.getId();
			if (filterToDelete) {
				var filterKey = this.metadataColumn.getType() === 'fact' ? this.visModel.localFilters.getOrdinalFilterKey( /*itemId*/ filterToDelete, this.metadataColumn.getDefaultAggregation()) :
					this.visModel.localFilters.getCategoryFilterKey( /*itemId*/ filterToDelete);
				return filterKey;
			}
			return null;
		}
	});

	return DeleteFilterAction;

});
